import { Theme } from '@mui/material/styles'

const usePasswordStyles = {
  passwordCriteriaIcon: {
    marginRight: '5px',
  },
  passwordCriteriaBulletPoint: {
    margin: 0,
    width: '20px',
    height: '20px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  passwordCriteriaBulletPointIcon: (theme: Theme) => ({ fontSize: '6px', color: theme.palette.text.secondary }),
  passwordReqTypography: {
    display: 'inline',
    verticalAlign: 'top',
    flex: 1,
  },
  passwordCriteriaMet: (theme: Theme) => ({
    color: theme.palette.text.disabled,
  }),
}
export default usePasswordStyles
